/* eslint-disable security/detect-object-injection */
import {ZodNullable, ZodObject, ZodOptional, ZodRawShape, ZodTypeAny} from 'zod';

function unwrapOptionals(type: ZodTypeAny): {
  type: ZodTypeAny;
  optional: boolean;
  nullable: boolean;
} {
  let current: ZodTypeAny = type;
  let optional = false;
  let nullable = false;
  if (current instanceof ZodOptional) {
    optional = true;
    current = current.unwrap();
  }
  if (current instanceof ZodNullable) {
    nullable = true;
    current = current.unwrap();
  }
  return {type: current, optional, nullable};
}

export function getRequiredZodFieldPaths(schema: ZodTypeAny, prefix = ''): string[] {
  const paths: string[] = [];
  const root = unwrapOptionals(schema);
  if (root.type instanceof ZodObject) {
    const shape: ZodRawShape = root.type.shape;
    for (const key of Object.keys(shape)) {
      const child = shape[key];
      const unwrapped = unwrapOptionals(child);
      const path = prefix ? `${prefix}.${key}` : key;
      if (unwrapped.type instanceof ZodObject) {
        // Only include nested fields if the parent object is required and non-nullable
        if (!unwrapped.optional && !unwrapped.nullable) {
          paths.push(...getRequiredZodFieldPaths(unwrapped.type, path));
        }
      } else {
        // Include only when field is required and non-nullable
        if (!unwrapped.optional && !unwrapped.nullable) {
          paths.push(path);
        }
      }
    }
  }
  return paths;
}
